import { useEffect } from "react";
import { useLocation } from "wouter";

export function useDismissOnEsc(backHref: string) {
  const [_, navigate] = useLocation();

  useEffect(() => {
    const controller = new AbortController();

    window.addEventListener(
      "keydown",
      (event) => {
        if (event.key === "Escape") {
          navigate(backHref);
        }
      },
      { signal: controller.signal },
    );

    return () => {
      controller.abort();
    };
  }, [backHref, navigate]);
}
